import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import React from 'react';

interface GreeterProps {
  firstName: string;
  lastName: string;
  style?: React.CSSProperties;
}

export const Greeter = (props: GreeterProps) => {
  const { firstName, lastName, style } = props;

  const { palette } = useTheme();

  return (
    <Typography variant="h4" gutterBottom style={style}>
      Welcome back,{' '}
      <span style={{ color: palette.primary.main }}>
        {`${firstName} ${lastName}`}!
      </span>
    </Typography>
  );
};
